module.exports = {"preferred-locale":{"header":"Taal","button":"Taal wijzigen"}};